export const mainHeaderHeight = '50px';
